import {gql} from 'apollo-angular';

import { promisesSponsorshipsFragment } from '../fragments/promises-sponsorships.gql';
import { promisesMatchingGiftsFragment } from '../fragments/promises-matching-gifts.gql';
import { distributionsFragment } from '../fragments/distributions.gql';

export const donationTablesGql = gql`
    query ReloadDonationTablesGql($participantId: [Int!]){
        Participant(participantId: $participantId) {
            participantId
            event {
              eventId
            }
            ${promisesSponsorshipsFragment}
            ${promisesMatchingGiftsFragment}
            ${distributionsFragment}
        }
    }
`;
